
<table class="width-100per">
  <thead>
    <tr class="border-bottom-0px">
      <td>
        <div class="printheader-space">&nbsp;</div>
      </td>
    </tr>
  </thead>
  <tbody>
    <tr class="border-bottom-0px">
      <td>
        <div class="content">
          <router-outlet></router-outlet>
          <router-outlet name="print"></router-outlet>      
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="border-bottom-0px">
      <td>
        <div class="printfooter-space">&nbsp;</div>
      </td>
    </tr>
  </tfoot>
</table>




<div>
  <div class="printheader border-bot-1px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">
        <div class="col-md-12 padding-left-0px">
          <!--<div class="row margin-left-0px" *ngIf="SelectedPatientFormattedCode.FacilityName != 'Risaa IVF' && SelectedPatientFormattedCode.FacilityName != 'Ferticare IVF Assist'">-->
            <div class="row margin-left-0px">
              <div class="col-md-1 padding-left-0px padding-right-0px">
                <img [src]="logo"
                     [style.width.px]="PrintlogoWidth"
                      [style.height.px]="PrintlogoHeight"
                     [style.border-radius.%]="PrintlogoBorderRadius"
                     class="">
              </div>

              <div class="col-md-6">
                <div class="row margin-left-0px">
                  <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
                </div>
                <div class="row margin-left-0px">
                  <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
                </div>
                <!--<div class="row margin-left-0px" *ngIf="GST">
        <div class="col-print-2">
          <label class="margin-bottom-0px font-family font-weight-normal">GST:</label>
        </div>
        <div class="col-print-10">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
        </div>
      </div>
      <div class="row margin-left-0px" *ngIf="DL">
        <div class="col-print-2">
          <label class="margin-bottom-0px font-family font-weight-normal">CIN:</label>
        </div>
        <div class="col-print-10">
          <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
        </div>
      </div>-->
              </div>

              <!--<div class="col-md-5 padding-right-5px border-color-blue">


    </div>-->
            </div>

            <!--<div class="row margin-left-0px" *ngIf="SelectedPatientFormattedCode.FacilityName == 'Risaa IVF' || SelectedPatientFormattedCode.FacilityName == 'Ferticare IVF Assist'">
              <div class="col-md-1 padding-left-0px padding-right-0px">
                <img [src]="logo" class="" width="350px" height="100px">
              </div>

              <div class="col-md-6">
                <div class="row margin-left-0px">
                  <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
                </div>
                <div class="row margin-left-0px">
                  <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
                </div>

              </div>

            </div>-->
          </div>
      </div>


    </div>
  </div>

  <div class="printfooter">
    <!--<div *ngIf="ShowFooterMore" class="card-body padding-top-0px padding-bottom-0px">
      am in Footer....

      <br />

      am in Footer after  break...
    </div>-->
    <div class="card footerborder-top">

      <div class="card-header border-bottom-0px padding-bottom-0px padding-top-5px padding-left-0px padding-right-0px">

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px background-color-wt">
        <div class="row margin-left-0px">

          <div class="col-md-8 footerborder-right">

            <div class="row margin-left-0px text-align-center">
              <label class="margin-bottom-0px font-weight-normal font-family text-align-center">{{ClientHeaderFooterLine1}}</label>
            </div>
            <div class="row margin-left-0px text-align-center">
              <label class="margin-bottom-0px font-weight-normal font-family text-align-center">{{ClientHeaderFooterLine2}}</label>
            </div>
            <div class="row margin-left-0px text-align-center">
              <label class="margin-bottom-0px font-weight-normal font-family text-align-center">{{ClientHeaderFooterLine3}}</label>
            </div>
            <div class="row margin-left-0px text-align-center">
              <label class="margin-bottom-0px font-weight-normal font-family text-align-center">{{ClientHeaderFooterLine4}}</label>
            </div>

          </div>

        </div>
        <!--<div class="row">
        <div class="col-md-9">

        </div>
        <div class="col-md-3">
          <label class="margin-bottom-0px font-family13px">Print Taken: {{Date | date:'dd-MMM-yyyy'}}</label>
        </div>
      </div>-->
        <!--<div class="row">
        <div class="col-print-9">

        </div>
        <div class="col-print-3">
          <label class="margin-bottom-0px font-family13px footer_info_Mh"></label>
        </div>
      </div>-->
      </div>

    </div>

  </div>

</div>
